export default __webpack_public_path__ + "static/illust-8b445c393d1732487558b56c04663c6a.png";